import Loading from "../../results/loading";
import Random from "../../results/random";
import React from "react";
import { byAPrefix, byCodes, getPostNum } from "../../../constant/General";
import ContentWrapper from "./ContentWrapper";


const RenderPosA = ({ posts, mr = "19px", top = "95px", field = "twoD", width = "140px", fontSize = "90px" }) => {
    return <div style={{
        top: top, left: "35px",
        fontSize: fontSize
    }} className="position-absolute d-flex post">
        {posts.map((post, i) => {
            return <div
                style={{
                    height: "95px", marginTop: "19px"
                }}
                className="d-flex" key={i}>
                <div style={{
                    marginRight: mr, width: width
                }}>{getPostNum(post[field])}</div>
            </div>
        })}
    </div>
}


const ResultMTNight = ({ result: { results, rightResults, }, config }) => {
    const post = {
        postBCD: byCodes(rightResults, ["B", "C", "D"]),
        postA3D: byAPrefix(rightResults, 3),
        postA2D: byAPrefix(rightResults, 4),
    };

    return <ContentWrapper>
        <div className="mt-live-ng w-50 overflow-hidden d-flex justify-content-end">
            <table style={{
                width: "810px"
            }} className="">
                <tbody>
                    {results.map((res, j) => {
                        const hlBG = config.ng.hlIndex.includes(j);
                        const style = {
                            background: hlBG ? config.hlBG : config.background
                        }
                        return <tr style={style} className={`row-${j}`} key={j}>

                            <td className="">
                                <div className="d-flex justify-content-around">
                                    {res.items.map((list, i) => {
                                        const style = config.ng.row[`row_${j}`]
                                        return <div className="" align="middle" key={`${j}_${i}`}>
                                            {list.map((num, index) => {
                                                if (num.includes("*")) {
                                                    return <div className="" key={index}>
                                                        <Loading style={style?.loading ?? config.loading}
                                                            className="loading-res"
                                                            sizeDigit={num.length} />
                                                    </div>
                                                }
                                                if (num.includes("?")) {
                                                    let randomSt = style?.random ? {
                                                        ...config.random,
                                                        ...style.random,
                                                    } : config.random
                                                    return <div key={index}>
                                                        <Random className="random-res" style={randomSt}
                                                            sizeDigit={num.length} />
                                                    </div>
                                                }
                                                return <div className="" style={{ ...style?.normal }}
                                                    key={index}>{num}</div>
                                            })}
                                        </div>
                                    })}
                                </div>
                            </td>


                        </tr>
                    })}
                </tbody>
            </table>
        </div>
        <div style={{
            backgroundImage: `url(${require(`../../../assets/images/live-v2/${config.type}/ng/bg.png`)})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "100% 100%",
        }} className="w-50 d-flex overflow-hidden justify-content-center align-items-center position-relative">
            <div className="position-relative">
                <img height="750" className="w-100"
                    src={require(`../../../assets/images/live-v2/${config.type}/ng/post.png`)}
                    alt="__" />

                <div style={{
                    bottom: "29px", left: "235px",
                    fontSize: "100px"
                }} className="position-absolute post">
                    {post.postBCD.map((post, i) => {
                        return <div
                            style={{
                                height: "100px", marginTop: "30px"
                            }}
                            className="d-flex" key={i}>
                            <div style={{
                                marginRight: "48px", width: "150px"
                            }}>{getPostNum(post.twoD)}</div>
                            <div>{getPostNum(post.threeD)}</div>
                        </div>
                    })}
                </div>

                <RenderPosA posts={post.postA2D} />
                <RenderPosA mr="14px"
                    fontSize="85px"
                    width="200px"
                    top="215px"
                    posts={post.postA3D}
                    field="threeD" />

            </div>
        </div>
    </ContentWrapper>
}

export default ResultMTNight;